import DocModuler from './../DocModuler';
import { versionCompare } from './extends';
import log from 'loglevel';

/**
 * 验证容器类型是否符合要求
 *
 * @export
 * @param {*} type
 * @returns
 */
export function verifyContainerType(type) {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      if (!this.container) {
        log.error(`无法执行${name}方法，容器实例为空`);
        return;
      }
      const oType = this.container.type;
      if (oType !== type) {
        log.warn(`无法在 ${oType} 实例上执行 ${name} 方法，该方法存在于 ${type} 实例上`);
        return;
      }

      return method.apply(this, args);
    };
  };
}

/**
 * 不推荐或弃用API提示信息
 *
 * @export
 * @param {*} msg 提示信息
 * @param {*} since 从哪个版本开始弃用、不推荐使用
 * @returns
 */
export function Deprecated(msg, since) {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      if (versionCompare(DocModuler.version, since) === 1) {
        log.warn(msg, ` since: ${since}, method: ${name}`);
      }
      return method.apply(this, args);
    };
  };
}

/**
 * 回放限定方法
 *
 * @export
 * @returns
 */
export function LimitInVod() {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      if (!this._vod) {
        let CLASS_NAME = target.constructor.name;
        log.error(
          `Method call failed, only used in Vod mode, before call method ${name}, you should set ${CLASS_NAME} instance property: isVod to true.`
        );
        return;
      }

      return method.apply(this, args);
    };
  };
}

/**
 * 防抖
 *
 * @export
 * @param {*} delay 时间间隔
 */
export function Debounce(delay) {}

/**
 * 节流
 *
 * @export
 * @param {*} n 时间间隔
 */
export function Throttle(n) {}
